export const API_PREFIX = process.env.API_PREFIX ? process.env.API_PREFIX: 'V2'
export const SESSION_ANSWER_TOKEN = 'session_answer_token'



// WEBPACK FOOTER //
// ./shared/globals.js